import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBybitCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M2.75 9h14.5V7.5H2.75V9ZM12 11a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M3.5 3.25A2.25 2.25 0 0 0 1.25 5.5v9a2.25 2.25 0 0 0 2.25 2.25h.75v1.75a2.25 2.25 0 0 0 2.25 2.25h13a2.25 2.25 0 0 0 2.25-2.25v-8a2.25 2.25 0 0 0-2.25-2.25h-.75V5.5a2.25 2.25 0 0 0-2.25-2.25h-13Zm15.25 6.5h.75a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-.75.75h-13a.75.75 0 0 1-.75-.75v-1.75H16.5a2.25 2.25 0 0 0 2.25-2.25V9.75Zm-16-4.25a.75.75 0 0 1 .75-.75h13a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-13a.75.75 0 0 1-.75-.75v-9Z"
    />
  </svg>
);
export default SvgTwoColorBybitCard;
